<script setup lang="ts">
import type { ComputedRef } from "vue";
import { SelectLabel, type SelectLabelProps, useForwardProps } from "reka-ui";

const props = withDefaults(defineProps<SelectLabelProps>(), {});
// Only the set props; typed as such (see HPixSelectArrow).
const forwarded = useForwardProps(props) as ComputedRef<SelectLabelProps>;
</script>

<template>
  <SelectLabel v-bind="forwarded">
    <slot />
  </SelectLabel>
</template>
